export const removeEmoji = (str: string): string => {
  return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g, '');
};

export const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const sanitizeName = (name: string): string => {
  return removeEmoji(name).replace(/[^a-zA-Z\s]/g, '');
};

export const sanitizePhone = (phone: string): string => {
  return removeEmoji(phone).replace(/[^0-9+\s()]/g, '');
};

export const sanitizePincode = (pincode: string): string => {
  return removeEmoji(pincode).replace(/[^0-9\s]/g, '').replace(/\s+/g, ' ').slice(0, 6);
};